/*
 * 生成随机字符串
 * */
export function randomString(len = 8) {
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const a = t.length
  let n = ''
  for (let i = 0; i < len; i++) n += t.charAt(Math.floor(Math.random() * a))
  // @ts-ignore
  return n.toString('hex')
}

export function randomPassword(minLength, maxLength) {
  const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength
  return randomString(length)
}

export function isValidHttpUrl(str: string): boolean {
  let url
  try {
    url = new URL(str)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

/**
 * 安全的方式将 String 转换成 JSON 对象，如果解析错误，会用 fallback 参数的值代替
 *
 * @example
 *
 * const json = safeParseJSON('{"a":1}')
 * // { a: 1 }
 *
 * const json = safeParseJSON<{ id: number, title: string }>('{"id":1, "title": "Hello world"}')
 * // { id: 1, title: "Hello world" }
 *
 * const json = safeParseJSON('invalid json')
 * // {}
 *
 * * const json = safeParseJSON('invalid json', [])
 * // []
 *
 * @param str JSON 字符串
 * @param fallback_val 如果解析错误，返回 fallback_val 的值，默认 {}
 * @returns
 */
export const safeParseJSON: <T = any>(str?: string, fallback?: any) => T = (str, fallback_val = {}) => {
  if (!str || str === 'null') {
    return fallback_val
  }
  try {
    return JSON.parse(str)
  } catch (e) {
    console.log('safeParseJSON parse error:', e)
    return fallback_val
  }
}

// alias localRootDomain
export function rootDomain(host: string) {
  return localRootDomain(host)
}

export const localRootDomain = (host: string) => {
  const domain = fullDomain(host)

  if (/^127\.0\.0\.1/.test(domain)) {
    return '127.0.0.1'
  }
  if (/^localhost/.test(domain)) {
    return 'localhost'
  }
  const [zeroDomain, firstDomain] = domain.split('.').reverse()
  return `.${firstDomain}.${zeroDomain}`
}

export const fullDomain = (host: string) => {
  const [, domain_port] = host.split('://')
  const [domain] = (domain_port || host).split(':')
  return domain
}

type ComputedOptions = {
  fontSize?: string
  fontWeight?: string | number
  fontFamily?: string
  offset?: number
}

/**
 * 去掉前后空格，优化搜索
 */
export const trimParams = (params: Record<string, any>): Record<string, any> => {
  Object.keys(params).forEach(key => {
    if (typeof params[key] === 'string') {
      params[key] = params[key].trim()
    }
  })
  return params
}


const FILTER_PASSWORD_RE = /pass|secret|token|authorization|cookie/i
/**
 * 过滤对象中的「密码、Token、Secret」信息，改成 "****"
 * @param data
 * @returns
 */
export const filterPassword = (data: any) => {
  if (!data) {
    return data
  }

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'string' && FILTER_PASSWORD_RE.test(key)) {
      const maskValue = `********** (len: ${value.length})`

      data[key] = maskValue
    } else if (typeof value === 'object') {
      data[key] = filterPassword(value)
    }
  })

  return data
}

/**
 * 是否包含中文字符
 */
export const containsChinese = (str?: string) => {
  if (!str) return false
  // 使用正则表达式匹配中文字符
  const chineseRegex = /[\u4e00-\u9fa5【】！，。（）‘’“”《》？、]/
  return chineseRegex.test(str)
}

export function renderText(val: string) {
  let result = ''
  try {
    const arr = safeParseJSON<{ name: string; value: string }[]>(val) || []
    const filterArr = arr
      .filter(item => {
        return !!item.name
      })
      .map(item => {
        if (!!item.name && !!item.value) {
          return `${item.name} ${item.value}`
        } else {
          return `${item.name}`
        }
      })

    result = filterArr.join('\n')
  } catch (e) {
    console.log(e)
  }
  return result
}
